module.exports = __webpack_public_path__ + "535da898c9531275d69d1b8624f98bf0.svg";